import './PrimeiraSecao.css';

export default function PrimeiraSecao(){
    return(
        <section className="texto-banner">
                <div id="escrita">
                    <p>Preços baixos em</p>
                    <h1>Óculos de <br />
                        grau e de sol</h1>
                    <p>Você só encontra aqui</p>
                </div>  
        </section>
    );
}